import type { UserInformation } from "@/api/signin";
import { useRefreshAccessToken } from "@/features/auth/useRefreshAccessToken";
import { AuthProvider } from "@/context/auth-context";
import { useLoaderData } from "@tanstack/react-router";
import { ReactNode } from "react";

function AuthSessionRefresh() {
	useRefreshAccessToken();
	return null;
}

interface AuthWrapperProps {
	children: ReactNode;
	from?: "/main" | "/alt";
}

const AuthWrapper = ({ children, from = "/main" }: AuthWrapperProps) => {
	const data = useLoaderData({ from }) as { user: UserInformation };

	const value = {
		user: data.user,
	};

	return (
		<AuthProvider value={value}>
			<AuthSessionRefresh />
			{children}
		</AuthProvider>
	);
};

export default AuthWrapper;
